// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".formulate-input-errors[data-v-678d0868]{color:red}.custom-time-picker .preview input[data-v-678d0868]{border:1px solid #78909c;height:2.2em;padding:.1em;font-size:1.3em}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
